import React, { useContext } from 'react'
import { HightLight, Text } from '../gameRulesStyle'
import { InputWrapper } from './elements/ElementsStyles'
import Increase from './elements/increase'
import Inputs from './elements/Input'
import { MyContext } from '../../../context/createContext'

export default function Auto({ prec, curr }: any) {
  const { context } = useContext(MyContext)
  return (
    <>
      <HightLight fontSize='22px' background='green' margin='15px 0'>
        AutoPlay
      </HightLight>
      <Text margin='15px 0'>
        You can set the desired number of rolls and max bet of your choice{' '}
      </Text>
      <InputWrapper>
        <Inputs label='number of rolls' value='100' />
        <Inputs
          label='max bet'
          value={curr + (+context.config.maxbet).toFixed(prec)}
        />
      </InputWrapper>
      <Text margin='15px 0'>
        In this field you can input an option to increase or decrease the bet
        percentage after the{' '}
        <HightLight fontSize='18px' background='green'>
          winning
        </HightLight>{' '}
        or{' '}
        <HightLight fontSize='18px' background='grey'>
          losing
        </HightLight>{' '}
        hand.{' '}
      </Text>
      <InputWrapper>
        <Increase label='on win' value='100%' subLabel='increase' />
        <Increase label='on loss' value='100%' subLabel='increase' />
      </InputWrapper>
      <Text margin='15px 0'>
        Enables you to stop autoplay when a certain{' '}
        <HightLight fontSize='18px' background='green'>
          profit
        </HightLight>{' '}
        or{' '}
        <HightLight fontSize='18px' background='grey'>
          loss
        </HightLight>{' '}
        number is reached.{' '}
      </Text>
      <InputWrapper>
        <Inputs label='stop on loss' value={curr + '100.00'} />
        <Inputs label='stop on profit' value={curr + '100.00'} />
      </InputWrapper>
    </>
  )
}
